import React from 'react'
import { classnames } from '@guillotinaweb/react-gmi'

export const ErrorZone = ({ children, id, className }) => {
  return (
    <div
      className={classnames(['notification', 'is-danger', className])}
      id={id}
    >
      {children}
    </div>
  )
}
